module.exports = __webpack_public_path__ + "img/calling copy.e3196065.svg";